var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0b75c2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.917 8.667V6c0-3.333-1.334-4.667-4.667-4.667h-4C2.917 1.333 1.583 2.667 1.583 6v4c0 3.333 1.334 4.667 4.667 4.667h2.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0b75c2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.137 9.66 6.723 7.6a.67.67 0 0 1 .94-.12l1.22.96a.674.674 0 0 0 .94-.113l1.54-1.987m1.874 4.207.186.38c.094.186.327.36.534.4l.253.04c.76.126.94.686.393 1.24l-.233.233a.84.84 0 0 0-.193.68l.033.14c.207.92-.28 1.273-1.08.793l-.173-.1a.82.82 0 0 0-.747 0l-.173.1c-.807.487-1.294.127-1.08-.793l.033-.14a.84.84 0 0 0-.193-.68l-.234-.233c-.546-.554-.366-1.114.394-1.24l.253-.04c.2-.034.44-.214.533-.4l.187-.38c.36-.727.947-.727 1.307 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteChart);
export default __webpack_public_path__ + "static/media/favorite-chart.bc7f42b2b21bd4cec029a4d1ead5af45.svg";
export { ForwardRef as ReactComponent };